import { api, tokenStorage } from '@/lib/api'
import type { AuthResponse, LoginPayload, RegisterPayload, User, MfaResponse, VerifyMfaPayload, ResetPasswordPayload } from '@/types/auth.types'

export const authService = {
  async login(payload: LoginPayload): Promise<AuthResponse | MfaResponse> {
    const data = await api.post<AuthResponse | MfaResponse>('/auth/login', payload)
    if ('token' in data) {
      tokenStorage.set(data.token)
      if (data.refreshToken) {
        tokenStorage.setRefreshToken(data.refreshToken)
      }
    }
    return data
  },

  async loginPersonal(payload: LoginPayload): Promise<(AuthResponse & { personalCompany?: any }) | MfaResponse> {
    const data = await api.post<(AuthResponse & { personalCompany?: any }) | MfaResponse>('/auth/login-personal', payload)
    if ('token' in data) {
      tokenStorage.set(data.token)
      if (data.refreshToken) {
        tokenStorage.setRefreshToken(data.refreshToken)
      }
    }
    return data
  },

  async verifyMfa(payload: VerifyMfaPayload): Promise<AuthResponse> {
    const data = await api.post<AuthResponse>('/auth/verify-mfa', payload)
    tokenStorage.set(data.token)
    if (data.refreshToken) {
      tokenStorage.setRefreshToken(data.refreshToken)
    }
    return data
  },

  async register(payload: RegisterPayload): Promise<AuthResponse> {
    const data = await api.post<AuthResponse>('/auth/register', payload)
    tokenStorage.set(data.token)
    if (data.refreshToken) {
      tokenStorage.setRefreshToken(data.refreshToken)
    }
    return data
  },

  async registerPersonal(payload: { full_name: string; email: string; password: string; cpf?: string }): Promise<AuthResponse & { company?: any }> {
    const data = await api.post<AuthResponse & { company?: any }>('/auth/register-personal', payload)
    tokenStorage.set(data.token)
    if (data.refreshToken) {
      tokenStorage.setRefreshToken(data.refreshToken)
    }
    return data
  },

  async logout(): Promise<void> {
    tokenStorage.remove()
    tokenStorage.removeRefreshToken()
  },

  async resetPassword(payload: ResetPasswordPayload): Promise<{ success: boolean; message: string }> {
    const data = await api.post<{ success: boolean; message: string }>('/auth/reset-password', payload)
    return data
  },

  async forgotPassword(email: string): Promise<{ success: boolean; message: string }> {
    const data = await api.post<{ success: boolean; message: string }>('/auth/forgot-password', { email })
    return data
  },

  async getMe(): Promise<User> {
    const data = await api.get<{ user: User }>('/auth/me')
    return data.user
  },
}
